export const iconFontAwesomePoliticalHandFist = (
	<i className="fa-solid fa-hand-fist"></i>
);
